import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AccountCircle, Home, Lock, Person } from "@mui/icons-material";
import axios from "axios";
import {
  TextField,
  Button,
  Grid,
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Card,
  CardContent,
  Snackbar,
  Alert,
  MenuItem, InputAdornment, IconButton
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import "../../components/style.css"
import AdminDashboard from "./AdminDashboard";

const UserRegistration = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    ComID: "EH25",
    ReferralVia:"",
    password: "",
    VendorType: "",
    firstName: "",
    lastName: "",
    DisplayName: "",
    Address: "",
    City: "",
    Province: "",
    Landmark: "",
    Country: "",
    phone: "",
    email: "",
    DOB: "",
    DOC: "",
    BkName: "",
    BkBranch: "",
    BkAcName: "",
    BkAcNo: "",
    BkAcType: "",
    NomName: "",
    NomRelation: "",
    NomMobile: "",
    PVValue: 100,
    CurrPCB: "Active",
    CurrRAB: "Valid",
  });

  const [activeStep, setActiveStep] = useState(0);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const handleBlur = () => {
    if (formData.email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      setError(true);
      setErrorMessage("Invalid email format");
    }
  };
  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Validate Mobile Number
    if (name === "phone") {
      if (!/^\d{0,10}$/.test(value)) {
        return; // Prevent invalid characters
      }
    }
  
    setFormData({ ...formData, [name]: value });
    setError(false);
    setErrorMessage("");
  };
  

  // Handle Next & Back Steps
  const handleNext = () => {
    if (activeStep === 1) {
      if (
        !formData.firstName ||
        !formData.lastName ||
        !formData.email ||
        !formData.phone ||
        !formData.password ||
        !formData.VendorType ||
        !formData.DOB ||
        // !formData.DOC 
        !formData.ReferralVia
      ) {
        setSnackbar({ open: true, message: "Please fill all required fields in Personal Info", severity: "error" });
        return; // Stop user from going to the next step
      }
    }
  
    setActiveStep((prevStep) => prevStep + 1);
  };
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };
  
  const handleBack = () => setActiveStep((prevStep) => prevStep - 1);

  // Handle API Call on Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await axios.post("https://testing.esnep.com/magnessa/api/bo/register", formData, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 200) {
        setSnackbar({ open: true, message: "Registration successful!", severity: "success" });
        setTimeout(() => navigate("/user-registration"), 2000); // Redirect after success
      } else {
        throw new Error("Registration failed. Please try again.");
      }
    } catch (error) {
      setSnackbar({ open: true, message: error.response?.data?.message || "An error occurred.", severity: "error" });
    }
  };

  // Stepper Configuration
  const steps = [
    { label: "Referral Info", icon: <Person /> },
    { label: "Personal Info", icon: <Person /> },
    { label: "Address", icon: <Home /> },
    { label: "Bank Details", icon: <Lock /> },
    { label: "Nominee", icon: <AccountCircle /> },
  ];

  // Get step content
  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Grid container spacing={2}>
             <Grid item xs={6}>
              <TextField fullWidth label="Referral Code" name="ReferralVia" value={formData.ReferralVia} onChange={handleChange} required />
            </Grid>
            <Grid item xs={6}>
  <TextField
    select
    fullWidth
    label="Vendor Type"
    name="VendorType"
    value={formData.VendorType}
    onChange={handleChange}
    required
    sx={{
      '& .MuiSelect-select': {
        py: 1.2,  // Adjust padding to match other inputs
        fontSize: '0.875rem' // Match font size
      },
      '& .MuiOutlinedInput-input': {
        pr: '32px !important' // Reduce right padding for arrow
      }
    }}
    InputProps={{
      sx: {
        '& .MuiSvgIcon-root': { // Style the dropdown icon
          fontSize: '1.2rem',
          right: 8
        }
      }
    }}
  >
    <MenuItem value="SUN" sx={{ fontSize: '0.875rem' }}>Sun</MenuItem>
    <MenuItem value="MOON" sx={{ fontSize: '0.875rem' }}>Moon</MenuItem>
  </TextField>
</Grid>
          </Grid>
        );

      case 1:
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="First Name" name="firstName" value={formData.firstName} onChange={handleChange} required />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Last Name" name="lastName" value={formData.lastName} onChange={handleChange} required />
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth label="Email" name="email" type="email" value={formData.email} onChange={handleChange} required  onBlur={handleBlur}  error={error}
          helperText={errorMessage} // Show error only when focus is lost
           />
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth label="Mobile No." name="phone" type="tel" value={formData.phone} onChange={handleChange} required />
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth label="Password" name="password" type="password" value={formData.password} onChange={handleChange} required />
            </Grid>
           

            <Grid item xs={4}>
              <TextField fullWidth label="DOB" name="DOB" type="date" value={formData.DOB} onChange={handleChange} InputLabelProps={{ shrink: true }} required />
            </Grid>
            <Grid item xs={4}>
  <TextField
    fullWidth
    label="Upload Document"
    value={selectedFile ? selectedFile.name : ""}
    InputProps={{
      readOnly: true,
      endAdornment: (
        <InputAdornment position="end">
          <input
            accept=".pdf,.doc,.docx,.jpg,.png"
            style={{ display: "none" }}
            id="upload-button-file"
            type="file"
            onChange={handleFileChange}
          />
          <label htmlFor="upload-button-file">
            <IconButton component="span">
              <CloudUploadIcon />
            </IconButton>
          </label>
        </InputAdornment>
      ),
    }}
  />
</Grid>
          
          </Grid>
        );
      
      case 2:
        return (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField fullWidth label="Address" name="Address" value={formData.Address} onChange={handleChange} required />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="City" name="City" value={formData.City} onChange={handleChange} required />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="State/Province" name="Province" value={formData.Province} onChange={handleChange} required />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="Country" name="Country" value={formData.Country} onChange={handleChange} required />
            </Grid>
          </Grid>
        );

      case 3:
        return (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField fullWidth label="Bank Name" name="BkName" value={formData.BkName} onChange={handleChange} required />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="Account Number" name="BkAcNo" value={formData.BkAcNo} onChange={handleChange} required />
            </Grid>
          </Grid>
        );

      case 4:
        return (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField fullWidth label="Nominee Name" name="NomName" value={formData.NomName} onChange={handleChange} required />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="Nominee Relation" name="NomRelation" value={formData.NomRelation} onChange={handleChange} required />
            </Grid>
          </Grid>
        );

      default:
        return <Typography>Error: Unknown Step</Typography>;
    }
  };

  return (
    <>
      <AdminDashboard>
        <Box component="main" sx={{ 
                      flexGrow: 1,
                      p: 3,
                      backgroundColor: "#f7f7f7",
                      minHeight: '100vh'
                    }}>
                  
                      
                      <Box>
                        <Typography variant="h5" fontWeight={600}>
                          User Registration
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{lineHeight:"2"}}>
                        You can create an account of a user on a platform by providing relevant information.
                        </Typography>
                      </Box>

<Box sx={{ 
  display: "flex", 
  justifyContent: "center", 
  alignItems: "center", 
  minHeight: "80vh", 
  p: 2,
  background: 'linear-gradient(45deg, #f5f7fa 0%, #c3cfe2 100%)'
}}>
  <Card sx={{ 
    width: "100%", 
    maxWidth: 800, 
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
    borderRadius: 4,
    overflow: 'visible',
    position: 'relative',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: -16,
      left: -16,
      right: -16,
      bottom: -16,
      bgcolor: 'rgba(255,255,255,0.4)',
      borderRadius: 4,
      zIndex: -1
    }
  }}>
    <CardContent sx={{ p: 4 }}>
      <Stepper 
        activeStep={activeStep} 
        alternativeLabel
        sx={{
          '& .MuiStepLabel-label': {
            fontWeight: 600,
            color: 'text.secondary',
            '&.Mui-active': { color: 'primary.main' },
            '&.Mui-completed': { color: 'success.main' }
          }
        }}
      >
        {steps.map((step, index) => (
          <Step key={index}>
            <StepLabel 
              StepIconComponent={(props) => {
                const isActive = activeStep === index;
                return React.cloneElement(steps[index].icon, { 
                  sx: { 
                    fontSize: 32,
                    color: props.completed ? 'success.main' : 
                           isActive ? 'primary.main' : 'action.disabled',
                    bgcolor: 'background.paper',
                    p: 1,
                    borderRadius: '50%',
                    boxShadow: 1
                  }
                });
              }}
              sx={{
                '& .MuiStepLabel-labelContainer': {
                  mt: 1
                }
              }}
            >
              <Typography variant="subtitle2" fontWeight={600}>
                {step.label}
              </Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>

      <Box sx={{ 
        mt: 4,
        px: { xs: 0, sm: 4 },
        py: 3,
        borderRadius: 2,
        bgcolor: 'background.paper',
        boxShadow: '0 4px 20px rgba(0,0,0,0.05)'
      }}>
        {getStepContent(activeStep)}

        <Box sx={{ 
          display: "flex", 
          justifyContent: "space-between", 
          mt: 4,
          gap: 2,
          '& .MuiButton-root': {
            borderRadius: 2,
            py: 1.5,
            px: 4,
            fontWeight: 600,
            textTransform: 'none',
            transition: 'all 0.2s ease'
          }
        }}>
          {activeStep > 0 && (
            <Button 
              variant="outlined" 
              color="secondary"
              onClick={handleBack}
              sx={{
                borderWidth: 2,
                '&:hover': {
                  borderWidth: 2,
                  bgcolor: 'action.hover'
                }
              }}
            >
              Back
            </Button>
          )}
          
          {activeStep < steps.length - 1 ? (
            <Button 
              variant="contained" 
              onClick={handleNext}
              sx={{
                ml: 'auto',
                bgcolor: 'primary.main',
                '&:hover': {
                  bgcolor: 'primary.dark',
                  transform: 'translateY(-1px)'
                }
              }}
            >
              Next Step
            </Button>
          ) : (
            <Button 
              variant="contained" 
              color="success"
              onClick={handleSubmit}
              sx={{
                ml: 'auto',
                bgcolor: 'success.main',
                '&:hover': {
                  bgcolor: 'success.dark',
                  transform: 'translateY(-1px)'
                }
              }}
            >
              Create Account
            </Button>
          )}
        </Box>
      </Box>
    </CardContent>
  </Card>
</Box>
</Box>
      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
  
    </AdminDashboard>
    </>
  );
};

export default UserRegistration;
